/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_OkInputs */

const en_tut_wb_ok = /** @type {(inputs: Tut_Wb_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The **Semua perubahan tersimpan** indicator appears, and people in the same meeting or area see your objects without reloading.`)
};

const id_tut_wb_ok = /** @type {(inputs: Tut_Wb_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indikator **Semua perubahan tersimpan** muncul, dan rekan di rapat atau area yang sama melihat objek Anda tanpa memuat ulang.`)
};

/**
* | output |
* | --- |
* | "The **Semua perubahan tersimpan** indicator appears, and people in the same meeting or area see your objects without reloading." |
*
* @param {Tut_Wb_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_ok = /** @type {((inputs?: Tut_Wb_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_ok(inputs)
	return en_tut_wb_ok(inputs)
});